import { ENVIRONMENT as env } from '@updater-core/lib/environment';
import { fetchGraphQLQuery } from '@updater-core/lib/graphql';
import gql from 'graphql-tag';
import { ERROR, track } from '@updater-core/lib/tracker';

function handleError(ex, source) {
  if (window.console && window.console.error) {
    console.error(ex); // eslint-disable-line no-console
  }
  track({
    verb: ERROR,
    object: `${source}_fetch_error`,
    details: {
      message: ex.message,
      stack: ex.stack,
      ...ex,
    },
  });
}

export function createGateway() {
  return {
    fetchSiteBranding: (inviteToken, headers) => {
      const query = gql`
        query siteBranding($input: SiteBrandingInput!) {
          siteBranding(input: $input) {
            subdomain
            entityBrandings {
              displayName
              name
              kind
              logoId
              type
              showBranding
              title
              teamName
              website
              phone
              socialBranding {
                facebook
                linkedin
                twitter
                website
              }
            }
            branding {
              displayName
              logoId
              name
              favicon {
                id
                baseUrl
              }
            }
            disclaimer
            journey
          }
        }
      `;

      return fetchGraphQLQuery({
        headers,
        query,
        url: `${env.endpoints.api.url}/graphql`,
        variables: {
          input: {
            inviteToken,
          },
        },
      })
        .then((response) => response?.data?.siteBranding)
        .catch((ex) => {
          handleError(ex, 'site_branding');
          return false;
        });
    },
  };
}
